import React from 'react'

import { Form, Select, Input } from 'formik-antd'

import { isNotValid, translateSymfonyErrorToFormik } from '../../../core/utils/form'

/* Form & Form Validation */
import * as Yup from 'yup'

import ModalForm from '../../../core/components/form/modalForm'

import { jobStatus, jobStatusRejected } from './const'

const validationSchema = Yup.object().shape({
  state: Yup.string().required('Cannot be blank'),
  notes: Yup.string().when('state', {
    is: jobStatusRejected,
    then: (fieldSchema) => fieldSchema.required('Cannot be blank.')
  })
})

const _filter = (input, option) => option.text.toLowerCase().indexOf(input.toLowerCase()) >= 0

const FormUpdateState = (props) => {
  const handleSubmit = (values, bag) => {
    const form = {
      notes: values.notes,
      status: values.state
    }

    const ret = props.updateState(form)

    ret.then((response) => {
      bag.setSubmitting(false)
      if (isNotValid(response)) {
        bag.setErrors(translateSymfonyErrorToFormik(response.errors.children))
      } else {
        props.onCancel()
      }
    }).catch((e) => {
      //alert("Se ha producido un error desconocido");
    })
  };

  const { modalVisible, onCancel } = props
  const values = { notes: '', state: props.state }

  if (!modalVisible) {
    return null
  }

  return (
    <ModalForm
      title='Edit status'
      enableReinitialize
      initialValues={values}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      visible={modalVisible}
      render={({ isSubmitting, touched, errors, values, setFieldValue, setFieldTouched }) => (
        <>
          <Form.Item label='Status' name='state' hasFeedback showValidateSuccess>
            <Select
              placeholder='Status'
              name='state'
              showSearch
              options={jobStatus.filter((e) => e.selectable)}
              filterOption={_filter}
            />
          </Form.Item>
          {values.state === jobStatusRejected && (
            <Form.Item label='Notes' name='notes'>
              <Input.TextArea name='notes' placeholder='Notes' />
            </Form.Item>
          )}
        </>
      )}
    />
  )
}

FormUpdateState.defaultProps = {
  modalVisible: false,
  state: 'New',
  updateState: async (state) => {},
  onCancel: async () => {}
}

export default FormUpdateState
